// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../images/31330.jpg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Contenidor principal del Dashboard */
.Dashboard {
  display: flex;
  flex-direction: column;
  height: 100vh;
  /*background-color: #f93939; /* COLOR TOCAT f9f9f9 */
  background: linear-gradient(
    rgba(255, 255, 255, 0.8), 
    rgba(255, 255, 255, 0.8)
  ),
  url(${___CSS_LOADER_URL_REPLACEMENT_0___}) no-repeat center center fixed;
  background-size: cover;
  font-family: Arial, sans-serif; /* Tipografia professional */
}

/* Barra de menú superior */
.menu-bar {
  display: flex;
  background-color: #f1f1f1; /* Gris claret */
  padding: 10px 20px;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.1); /* Ombra subtil */
  align-items: center;
  height: 50px;
}

/* Menús actius i inactius: sense fons ni quadrats */
.menu-item {
  margin: 0 15px;
  color: #000000; /* Negre per defecte */
  font-size: 16px;
  text-decoration: none; /* Sense subratllat */
  cursor: pointer;
  background: none; /* Elimina qualsevol fons */
  border: none; /* Elimina qualsevol vora o quadrat */
  outline: none; /* Elimina els contorns de focus */
}

/* Hover per menús actius */
.menu-item:hover {
  font-weight: bold; /* Negreta */
  color: #0078d7; /* Blau per destacar */
  /*text-decoration: underline; /* Subratllat */
}

/* Menús actius seleccionats */
.menu-item.active {
  font-weight: bold; /* Negreta */
  color: #0078d7; /* Blau per destacar */
  /*text-decoration: underline; /* Subratllat */
}

/* Menús deshabilitats */
.menu-item.disabled {
  color: #808080; /* Gris fosc */
  cursor: not-allowed; /* Icona de prohibit */
  text-decoration: none; /* Sense subratllat */
}

/* Contenidor del dropdown */
.dropdown {
  position: relative; 
  display: inline-block; /* Per col·locar-lo en línia a la menu-bar */
}

/* Botó principal del dropdown (ex. "Productes") 
.dropdown > .menu-item {
  /* Ja tens estil bàsic a .menu-item, 
     però si vols afegir algun indicador (fletxeta, etc.) ho pots fer aquí. 
}*/

/* Contenidor del submenú: posició absoluta i no visible per defecte */
.dropdown-content {
  display: none; 
  position: absolute; 
  background-color: #f1f1f1; /* Pots canviar el color de fons */
  min-width: 160px; /* Amplada mínima */
  box-shadow: 0px 8px 16px rgba(0,0,0,0.2); /* Ombra de submenú */
  padding: 5px 0; /* Espai vertical */
  z-index: 9999; /* Per sobre d'altres elements */
}

/* Fem que aparegui el submenú en fer hover al .dropdown */
.dropdown:hover .dropdown-content {
  display: block;
}

/* Estil dels botons o enllaços del submenú */
.dropdown-content .submenu-item {
  display: block;
  width: 100%;
  padding: 8px 16px;
  text-align: left; 
  background: none; 
  border: none;
  cursor: pointer;
  color: #000; 
  font-size: 14px;
  text-decoration: none;
}

/* Hover a cada element del submenú */
.dropdown-content .submenu-item:hover {
  background-color: #ddd;
  font-weight: bold;
}


/* Contingut del Dashboard */
.content {
  flex: 1 1;
  padding: 20px;
  overflow-y: auto; /* Scroll per continguts llargs */
  /*background-color: #06f390; /* COLOR TOCAT ffffff Fons blanc */
  background: transparent; /* Afegit en comptes de fons blanc */
  border-top: 1px solid #ddd; /* Separació entre la barra i el contingut */
  /*nous
  background: linear-gradient(
        rgba(255, 255, 255, 0.8), 
        rgba(255, 255, 255, 0.8)
      ), 
      url('../images/31330.jpg') no-repeat center center fixed;*/
}

/* Barra responsiva */
@media (max-width: 768px) {
  .menu-bar {
    flex-wrap: wrap; /* Reorganitza menús si no caben */
    justify-content: center;
  }

  .menu-item {
    font-size: 14px;
    margin: 5px 10px;
  }
}

/* Contenidor principal per a seccions del Dashboard */
.Dashboard-container {
  display: flex; /* Això no es toca */
  flex-direction: column;
  height: 100%;
  background-color: #f3f3f3; /* COLOR TOCAT f3f3f3 */
  font-family: Arial, sans-serif;
  padding: 20px;
  border-radius: 15px;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.1);
  overflow: hidden; /* AQUEST FA QUE DESAPAREIXI EL SCROLL SI NO LI FEM AL TBODY */
}

/* Pestanyes de navegació */
.Dashboard-tabs {
  display: flex;
  border-bottom: 2px solid #ddd; /* Línia de separació per a les pestanyes */
  margin-bottom: 20px;
  position: relative;
}

/* Barra de cerca reutilitzable */
.Dashboard-search-bar {
  margin-bottom: 10px;
  padding: 8px;
  width: 200px;
  box-sizing: border-box;
  font-size: 14px;
  border: 1px solid #ddd;
  border-radius: 5px;
}

.Dashboard-search-container {
  display: flex;
  flex-wrap: wrap; /* Permet que els elements es reorganitzin si l'espai és limitat */
  gap: 10px; /* Espai entre els elements */
  margin-bottom: 0px; /* Coherència amb altres files del formulari */
}



.Dashboard-tab {
  position: relative;
  padding: 10px 20px;
  margin-right: 5px;
  background-color: #f1f1f1; /* Fons gris claret */
  color: #000000; /* Text negre */
  font-size: 14px;
  font-weight: bold;
  text-align: center;
  cursor: pointer;
  border: 1px solid #ddd;
  border-bottom: none; /* Fusiona amb el fons del contingut */
  border-radius: 8px 8px 0 0; /* Forma de pestanya */
  transition: background-color 0.3s ease, color 0.3s ease;
  z-index: 1;
}

.Dashboard-tab:hover {
  background-color: #e0e0e0; /* Canvia a gris clar en hover */
}

.Dashboard-tab.active {
  background-color: #ffffff; /* Fons blanc per pestanya activa */
  color: #0078d7; /* Blau per pestanya activa */
  border: 1px solid #ddd;
  border-bottom: 2px solid #ffffff; /* Amaga la línia inferior per semblar activa */
  z-index: 2; /* Posa la pestanya activa al davant */
}


.Dashboard-tab.disabled {
  color: #808080;
  pointer-events: none;
  opacity: 0.5;
}

.Dashboard-tabs.subtaula .Dashboard-tab {
  color: red !important; /* Usa !important si el codi original té un color també amb !important */
}


/* Contingut de les pestanyes */
.Dashboard-content {
  flex: 1 1;
  padding: 20px;
  background-color: #f9f9f9;
  border: 1px solid #ddd;
  border-radius: 5px; /* Cantonades arrodonides */
  overflow-y: auto;
}

/* Llista general per a elements */
.Dashboard-list {
  list-style: none;
  padding: 0;
  margin: 0;
}

.Dashboard-item {
  display: flex;
  justify-content: space-between;
  padding: 10px;
  margin-bottom: 10px;
  background-color: #ffffff;
  border: 1px solid #ddd;
  border-radius: 5px;
  cursor: pointer;
  transition: background-color 0.3s ease, box-shadow 0.3s ease;
}

.Dashboard-item:hover {
  background-color: #f1f1f1;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.Dashboard-item strong {
  color: #000000;
}


/* Responsiu */
@media (max-width: 768px) {
  .Dashboard-container {
    padding: 10px;
  }

  .Dashboard-tab {
    font-size: 12px;
    padding: 8px 12px;
  }

  .Dashboard-item {
    flex-direction: column;
    align-items: flex-start;
  }
}

/***********************/
/* Taules de selecció */
/***********************/
/* Contenidor global per mantenir el scroll */
.Dashboard-table-container {
  width: 100%;
  max-height: calc(100vh - 262px); /* Barra d'accions. Canvi de 220 a 262. Espai disponible per a taula completa */
  overflow-y: auto; /* Activa el scroll vertical */
  border: 1px solid #ddd; /* Opcional: per fer visible els límits */
  box-sizing: border-box; /* Assegura alineació de mides */
  padding: 0;
}

/* Taula */
.Dashboard-table {
  width: 100%;
  font-size: 14px;
  table-layout: auto; /* Alineació segons contingut */
  border-collapse: separate; /* Manté les vores separades */
  border-spacing: 0;
}

/* Capçalera fixa */
.Dashboard-table thead {
  position: sticky;
  top: 0; /* Manté la capçalera fixa a la part superior */
  z-index: 10;
  background-color: white;
  box-shadow: 0px 2px 5px rgba(0, 0, 0, 0.1); /* Ombra subtil */
}

.Dashboard-table th {
  padding: 8px;
  border: 1px solid #ddd;
  text-align: left;
  background-color: #f4f4f9; /* Fons per a l'encapçalament */
  color: #333;
  cursor: pointer;
  font-weight: bold;
}

.Dashboard-table th.text-right,
.Dashboard-table td.text-right {
  text-align: right;
}

.Dashboard-table th.text-center,
.Dashboard-table td.text-center {
  text-align: center;
}

.Dashboard-table th.text-left,
.Dashboard-table td.text-left {
  text-align: left;
}


.Dashboard-table th:hover {
  background-color: #e0e0e0; /* Canvia el fons al passar per sobre */
}

/* Columnes compactes per data/hora */
.Dashboard-table .col-date,
.Dashboard-table .col-time,
.Dashboard-table .col-datetime {
  white-space: nowrap;                 /* evita salts de línia al TD */
  /*text-align: center;*/
  font-variant-numeric: tabular-nums;  /* monoespai per xifres */
}

/* amples per caràcters visibles */
.Dashboard-table .col-date      { width: 12ch; }  /* 10/10/2025 */
.Dashboard-table .col-time      { width: 7.5ch; } /* 16:40 */
.Dashboard-table .col-datetime  { width: 19ch; }  /* 10/10/2025 16:40 */

/* deixa que el text del TH pugui trencar si és llarg ("Data Creació", etc.) */
.Dashboard-table th.col-date,
.Dashboard-table th.col-time,
.Dashboard-table th.col-datetime {
  white-space: normal;
}

/* Cos */
.Dashboard-table tbody td {
  padding: 8px;
  border: 1px solid #ddd;
  text-align: left;
  white-space: nowrap; /* Evita que el text trenqui línies */
  overflow: hidden; /* Amaga text desbordant */
  text-overflow: ellipsis; /* Afegeix punts suspensius si cal */
}

/* Files alternades */
.Dashboard-table tbody tr:nth-child(even) {
  background-color: #f9f9f9; /* Fons per a files parells */
}

.Dashboard-table tbody tr:nth-child(odd) {
  background-color: #ffffff; /* Fons per a files senars */
}

.Dashboard-table tbody tr:hover {
  background-color: #d3d3d3; /* Canvia el fons al passar per sobre */
}

/* Fila seleccionada */
.Dashboard-table tbody .selected-row {
  background-color: #cce5ff !important; /* Blau clar per fila seleccionada */
  color: #004085; /* Blau fosc pel text */
  font-weight: bold; /* Ressalta el text */
  border-left: 4px solid #007bff; /* Línia a l'esquerra */
}

/* Ajust per al text de la fila seleccionada */
.Dashboard-table tbody .selected-row td {
  padding: 8px;
  text-align: left;
}

.Dashboard-table tbody .selected-row td.text-right {
  text-align: right;
}

.Dashboard-table tbody .selected-row td.text-center {
  text-align: center;
}

.Dashboard-table tbody .selected-row td.text-left {
  text-align: left;
}


/* Opcional: efecte hover diferenciat per a fila seleccionada */
.Dashboard-table tbody .selected-row:hover {
  background-color: #b3d7ff !important; /* Blau més intens al passar el ratolí */
}


/****************************/
/* Camps de plenat de dades */
/****************************/

/* Contenidor principal del formulari */
.Dashboard-form {
  display: flex;
  flex-direction: column;
  gap: 20px;
  /*padding: 20px;
  background-color: #ffffff;
  border: 1px solid #ddd;
  border-radius: 5px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);*/
}

.Dashboard-cerca {
  display: flex;
  flex-direction: row;
  gap: 20px;
}

/* Files del formulari */
.Dashboard-form-row {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  margin-bottom: 0px;
}

/* Columnes del formulari */
.Dashboard-form-column {
  display: flex;
  flex-direction: column; /* Col·loca els elements en columna */
  gap: 0px; /* Espai vertical entre els elements */
  margin-bottom: 0px; /* Espai inferior del bloc */
  align-items: flex-start; /* Alinea elements a l'inici horitzontal */
  width: 100%; /* Assegura que ocupa l'ample disponible */
}


.Dashboard-form label {
  display: flex;
  flex-direction: column; /* Organitza el contingut en columna */
  font-size: 14px;
  max-width: 250px; /* Ajusta si vols un màxim d'amplada */
  font-weight: bold; /* Destaquem els labels */
  margin-bottom: 0px; /* Separació entre camps */
}

.Dashboard-info-container {
  background-color: #f9f9f9; /* Fons clar i neutre */
  border: 1px solid #ddd; /* Frontera subtil */
  padding: 0px; /* Espai intern per a llegibilitat */
  border-radius: 4px; /* Cantonades arrodonides */
  margin-bottom: 5px; /* Espai inferior */
  font-size: 14px; /* Mida moderada del text */
  line-height: 1.6; /* Espaiat entre línies */
  color: #333; /* Color del text principal */
  display: flex; /* Layout per adaptar continguts */
  flex-direction: column; /* Col·locar en columna */
  gap: 0px; /* Separació entre línies */
}

.Dashboard-info-container strong {
  display: inline; /* Manté el text en línia */
  margin: 0; /* Elimina marges per defecte */
  padding: 0; /* Elimina espais interns */
}

.Dashboard-info-container br {
  line-height: 0; /* Elimina espai vertical extra pels salts de línia */
}

.Dashboard-info-container .info-inline {
  display: flex;
  gap: 2px; /* Espai entre Categoria i Tipus */
}

.Dashboard-form input,
.Dashboard-form textarea,
.Dashboard-form select {
  padding: 5px;
  font-size: 14px;
  border: 1px solid #ccc;
  border-radius: 4px;
  box-sizing: border-box;
}

.Dashboard-cerca input,
.Dashboard-cerca textarea,
.Dashboard-cerca select {
  padding: 5px;
  font-size: 14px;
  border: 1px solid #ccc;
  border-radius: 4px;
  box-sizing: border-box;
}

/* Textarea específic */
.Dashboard-form textarea {
  height: 60px;
  width: 600px;
  color: black;
  resize: vertical; /* Permet ajustar només verticalment */
}

/* Textarea transitori */
.Dashboard-form textarea.textarea-trans {
  color: gray; /* Text transitori en gris */
  font-style: italic; /* Text transitori en cursiva */
}


/* Inputs personalitzats per amplada */
.Dashboard-form .camp-llarg-input {
  width: 250px;
  color: black;
}

.Dashboard-form .camp-llarg-input-trans {
  color: gray; /* Només canviem el color al mode transitori */
  font-style: italic; /* Opcional: estil cursiva */
}

.Dashboard-form .camp-curt-input {
  width: 125px;
  color: black;
}

.Dashboard-form .camp-curt-input-trans {
  color: gray; /* Només canviem el color al mode transitori */
  font-style: italic; /* Opcional: estil cursiva */
}


.Dashboard-form .camp-mig-input {
  width: 200px;
  color: black;
}

.Dashboard-form .camp-mig-input-trans {
  color: gray; /* Només canviem el color al mode transitori */
  font-style: italic; /* Opcional: estil cursiva */
}


/* Camps específics per Professions i Tipus de Client */
.Dashboard-form .custom-input {
  padding: 5px;
  font-size: 14px;
  border: 1px solid #007bff; /* Blau suau per destacar */
  border-radius: 4px;
  box-sizing: border-box;
}

.Dashboard-form .custom-input:focus {
  outline: none;
  border-color: #0056b3; /* Blau més intens al fer focus */
  box-shadow: 0 0 4px #0056b3; /* Ombra subtil per indicar focus */
}

/* Error en el camp */
.Dashboard-form .custom-input.error {
  border-color: #dc3545; /* Vermell per indicar error */
  background-color: #f8d7da; /* Vermell clar de fons */
}

.Dashboard-form .custom-input.error:focus {
  border-color: #bd2130; /* Vermell més intens al fer focus */
}


/* camps read_only */

.Dashboard-form .readonly-input,
.Dashboard-form .readonly-textarea,
.Dashboard-form .readonly-checkbox {
  background-color: #f5f5f5; /* Fons gris clar */
  border: 1px solid #ccc; /* Vora suau */
  color: #666; /* Text en gris */
  pointer-events: none; /* Evita interaccions amb el ratolí */
}

/* Específic per als textarea */
.Dashboard-form .readonly-textarea {
  resize: none; /* Evita redimensionar */
  height: auto; /* Ajusta automàticament a la mida del text */
}

/* Específic per select */
.Dashboard-form .readonly-select {
  background-color: #f5f5f5; /* Fons gris clar, com els altres camps inactius */
  border: 1px solid #ccc; /* Vora suau */
  color: #666; /* Text en gris */
  pointer-events: none; /* Evita interaccions amb el ratolí */
  appearance: none; /* Elimina l'estil predeterminat del navegador */
}


/* Checkbox actiu */
.Dashboard-form .readonly-checkbox {
  appearance: auto; /* Estil natiu per checkbox editable */
  width: 16px;
  height: 16px;
  margin: 0;
  cursor: pointer;
}

/* Checkbox readonly */
.Dashboard-form .readonly-checkbox.readonly-input {
  appearance: none; /* Elimina l'estil natiu */
  background-color: #e0e0e0; /* Fons gris clar */
  border: 1px solid #ccc; /* Vora gris */
  width: 16px;
  height: 16px;
  display: inline-flex; /* Centrat amb flexbox */
  align-items: center; /* Centra verticalment */
  justify-content: center; /* Centra horitzontalment */
  position: relative;
  cursor: not-allowed; /* Indica que no és editable */
  pointer-events: none; /* Evita interaccions */
}

.Dashboard-form .readonly-checkbox.readonly-input:checked::before {
  content: '✔';
  font-size: 12px; /* Mida consistent amb els actius */
  color: #fff; /* ✔ blanc */
}

/* Checkbox label amb espaiat */
.Dashboard-form .checkbox-label {
  display: flex; /* Col·loca els elements en línia */
  flex-direction: row; /* Organitza en fila */
  font-size: 14px; /* Manté la mida del text uniforme */
  font-weight: bold; /* Coherència amb altres etiquetes */
  align-items: baseline; /* Alinea amb la línia de text de l'etiqueta */
  gap: 5px; /* Espai entre el label i el checkbox */
  margin-bottom: 15px; /* Mateixa separació que altres camps */
}



/* Resposta a pantalles petites */
@media (max-width: 768px) {
  .Dashboard-form-row {
      flex-direction: column;
      gap: 10px;
  }

  .Dashboard-form label {
      max-width: 100%;
  }
}

/*******************************/
/* Camps de consulta de dades */
/*****************************/

/* Secció general del formulari */
.Dashboard-form-section {
  background-color: #f9f9f9; /* Fons clar i neutre per consistència */
  border: 1px solid #ddd; /* Frontera subtil */
  padding: 10px; /* Espai intern més generós per separar elements */
  border-radius: 4px; /* Cantonades arrodonides per harmonia visual */
  margin-bottom: 10px; /* Espai inferior entre seccions */
  font-size: 14px; /* Mida moderada del text */
  color: #333; /* Color del text */
  display: flex; /* Disseny en columna */
  flex-direction: column;
  gap: 6px; /* Separació entre línies dins la secció */
}

/* Estil per a línies d'informació */
.info-inline {
  display: flex; /* Layout flexible per col·locar etiquetes i valors */
  align-items: center; /* Centrar verticalment */
  font-size: 14px; /* Mida del text consistent */
  line-height: 1.4; /* Espaiat moderat */
  padding: 2px 0; /* Lleuger espai intern */
  gap: 0px; /* Espai entre l'etiqueta i el valor */
  border-bottom: none; /* Treu la línia de separació */
}

.info-inline strong {
  color: #555; /* Color més destacat per a etiquetes */
  margin-right: 8px; /* Espai entre etiqueta i valor */
}

.info-inline:last-child {
  border-bottom: none; /* Treure la línia a l'últim element */
}


/**********/
/* Botons */
/**********/


.Dashboard-button-group {
  display: flex; /* Col·loca els elements en línia */
  justify-content: flex-start; /* Ajusta segons el disseny: start, center o space-between */
  gap: 10px; /* Espai entre els botons */
  margin-top: 20px; /* Opcional: separació superior dels botons */
}


/* Estils generals per als botons del Dashboard 
/* Botó d'Acceptar i Cancel·lar */
/* Estil base per a tots els botons del dashboard */
.Dashboard-btn {
  display: inline-block;
  padding: 10px 15px;
  font-size: 14px;
  font-weight: bold;
  text-align: center;
  cursor: pointer;
  border: none;
  border-radius: 5px;
  width: 100px; /* Amplada fixa com el botó d'inici de sessió */
  transition: background-color 0.3s ease, box-shadow 0.3s ease;
}

/* Botó Acceptar: Blau */
.Dashboard-btn-acceptar {
  background-color: #0078d7; /* Blau primari */
  color: #ffffff;
}

.Dashboard-btn-acceptar:hover {
  background-color: #005a9e; /* Blau més fosc */
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
}

/* Botó Cancel·lar: Vermell */
.Dashboard-btn-cancelar {
  background-color: #d9534f; /* Vermell */
  color: #ffffff;
}

.Dashboard-btn-cancelar:hover {
  background-color: #c9302c; /* Vermell més fosc */
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
}

.Dashboard-btn-icona {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 30px; /* Amplada del botó */
  height: 30px; /* Alçada del botó */
  padding: 0; /* Eliminem padding extra */
  border: 1px solid #ccc; /* Frontera coherent */
  border-radius: 50%; /* Botó rodó */
  background-color: #f5f5f5; /* Fons subtil */
  color: #333; /* Color del text/icona */
  font-size: 16px; /* Mida de la icona */
  line-height: 1; /* Evitem espais innecessaris */
  cursor: pointer;
  transition: background-color 0.2s, border-color 0.2s;
}

.Dashboard-btn-icona:hover {
  background-color: #e0e0e0; /* Canvi de fons en hover */
  border-color: #999; /* Canvi de frontera en hover */
}

.Dashboard-btn-icona:active {
  background-color: #d6d6d6; /* Fons actiu */
  border-color: #666; /* Frontera activa */
}

.Dashboard-btn-icona:disabled {
  background-color: #f5f5f5; /* Fons neutre per botó deshabilitat */
  border-color: #ccc;
  color: #999; /* Color del text més pàl·lid */
  cursor: not-allowed;
}

/* 🔹 Botons de Navegació (Anterior / Següent) */
.Dashboard-btn-navegar {
  background-color: #a0a0a0; /* Gris */
  color: #ffffff;
  font-size: 24px; /* Mida gran per a les fletxes */
  width: 60px; /* Mida més petita que els altres botons */
  height: 40px;
  padding: 5px;
  border-radius: 5px;
  transition: background-color 0.3s ease, box-shadow 0.3s ease;
}

.Dashboard-btn-navegar:hover {
  background-color: #888888; /* Un gris més fosc al passar-hi */
}



/**************************/
/* Mostrar Camps Estàtics */
/**************************/

.Dashboard-form-row label {
  font-weight: bold;
}

.Dashboard-form-row span {
  flex: 1 1;
  text-align: left;
}

/*****************************/
/* Modals: Finestra emergent */
/*****************************/

/* Fons del modal que bloqueja la resta de la pàgina */
.Dashboard-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5); /* Fons semi-transparent */
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

/* Contingut del modal */
.Dashboard-modal-content {
  position: relative;
  background-color: #ffffff;
  padding: 0;
  border-radius: 8px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  max-width: 500px; /* L'amplada màxima augmentada per contingut més complex */
  width: 90%; /* Afegeix més flexibilitat per a dispositius petits */
  text-align: left; /* Ajusta l'alineació per a contingut detallat */
  animation: Dashboard-modal-fade-in 0.3s ease-in-out;
  overflow: hidden; /* Amaga overflow per mantenir border-radius */
  max-height: 90vh; /* Evita que surti de la pantalla */
}

/* Capçalera del modal */
.Dashboard-modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 15px 20px;
  border-bottom: 1px solid #ddd;
  background-color: #f9f9f9;
}

.Dashboard-modal-header h3 {
  margin: 0;
  font-size: 18px;
  color: #333;
}

/* Cos del modal */
.Dashboard-modal-body {
  padding: 20px;
  overflow-y: auto;
  max-height: calc(90vh - 150px);
}

/* Peu del modal (botons) */
.Dashboard-modal-footer {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  padding: 15px 20px;
  border-top: 1px solid #ddd;
  background-color: #f9f9f9;
}

/* Botons del modal (antiga estructura, mantenir per compatibilitat) */
.Dashboard-modal-buttons {
  display: flex;
  justify-content: space-around;
  margin-top: 20px;
  gap: 10px; /* Separa els botons */
}

.Dashboard-modal-buttons button {
  padding: 10px 20px;
  font-size: 14px;
  font-weight: bold;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  transition: background-color 0.3s ease, box-shadow 0.3s ease;
}

/* Botó per tancar el modal */
.Dashboard-modal-close {
  background: transparent;
  border: none;
  font-size: 24px;
  cursor: pointer;
  color: #666;
  font-weight: normal;
  padding: 0;
  width: 30px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: color 0.2s;
}

.Dashboard-modal-close:hover {
  color: #d9534f;
}

/* Botó d'acceptar */
.Dashboard-modal-buttons .accept-btn {
  background-color: #0078d7;
  color: #ffffff;
}

.Dashboard-modal-buttons .accept-btn:hover {
  background-color: #005a9e;
}

/* Botó de cancel·lar */
.Dashboard-modal-buttons .cancel-btn {
  background-color: #d9534f;
  color: #ffffff;
}

.Dashboard-modal-buttons .cancel-btn:hover {
  background-color: #c9302c;
}

/* Opcional: Animació del modal */
@keyframes Dashboard-modal-fade-in {
  from {
    opacity: 0;
    transform: scale(0.9);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
}

/* Menús a la dreta */
/* Layout esquerra/dreta de la barra superior (no trepitja res existent) */
.menu-left {
  display: flex;
  align-items: center;
  gap: 8px;
}

.menu-right {
  margin-left: auto;        /* empeny aquest bloc cap a la dreta */
  display: flex;
  align-items: center;
  gap: 8px;
}

/* Xip d'empresa activa (opc.) */
.empresa-chip {
  padding: 4px 8px;
  border-radius: 12px;
  background: #f1f1f1;;
  font-size: 0.9rem;
}

/* Responsive (opc.) */
@media (max-width: 768px) {
  .menu-right {
    flex-wrap: wrap;
    justify-content: flex-end;
    gap: 6px;
  }
}

/*Afegit per scroll últim ítem amb barra d'accions*/

.action-toolbar {
  height: 42px;             /* alçada fixa perquè el càlcul sigui estable */
  padding: 6px 8px;         /* igual que ara, però la “height” mana */
  display: flex;
  gap: 8px;
  align-items: center;
  border-bottom: 1px solid #eee;
}





`, "",{"version":3,"sources":["webpack://./src/pages/dashboard.css"],"names":[],"mappings":"AAAA,uCAAuC;AACvC;EACE,aAAa;EACb,sBAAsB;EACtB,aAAa;EACb,oDAAoD;EACpD;;;;uEAIwD;EACxD,sBAAsB;EACtB,8BAA8B,EAAE,4BAA4B;AAC9D;;AAEA,2BAA2B;AAC3B;EACE,aAAa;EACb,yBAAyB,EAAE,gBAAgB;EAC3C,kBAAkB;EAClB,wCAAwC,EAAE,iBAAiB;EAC3D,mBAAmB;EACnB,YAAY;AACd;;AAEA,oDAAoD;AACpD;EACE,cAAc;EACd,cAAc,EAAE,sBAAsB;EACtC,eAAe;EACf,qBAAqB,EAAE,qBAAqB;EAC5C,eAAe;EACf,gBAAgB,EAAE,2BAA2B;EAC7C,YAAY,EAAE,qCAAqC;EACnD,aAAa,EAAE,kCAAkC;AACnD;;AAEA,2BAA2B;AAC3B;EACE,iBAAiB,EAAE,YAAY;EAC/B,cAAc,EAAE,sBAAsB;EACtC,6CAA6C;AAC/C;;AAEA,8BAA8B;AAC9B;EACE,iBAAiB,EAAE,YAAY;EAC/B,cAAc,EAAE,sBAAsB;EACtC,6CAA6C;AAC/C;;AAEA,wBAAwB;AACxB;EACE,cAAc,EAAE,cAAc;EAC9B,mBAAmB,EAAE,sBAAsB;EAC3C,qBAAqB,EAAE,qBAAqB;AAC9C;;AAEA,4BAA4B;AAC5B;EACE,kBAAkB;EAClB,qBAAqB,EAAE,4CAA4C;AACrE;;AAEA;;;;EAIE;;AAEF,sEAAsE;AACtE;EACE,aAAa;EACb,kBAAkB;EAClB,yBAAyB,EAAE,kCAAkC;EAC7D,gBAAgB,EAAE,mBAAmB;EACrC,wCAAwC,EAAE,qBAAqB;EAC/D,cAAc,EAAE,mBAAmB;EACnC,aAAa,EAAE,gCAAgC;AACjD;;AAEA,0DAA0D;AAC1D;EACE,cAAc;AAChB;;AAEA,6CAA6C;AAC7C;EACE,cAAc;EACd,WAAW;EACX,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,WAAW;EACX,eAAe;EACf,qBAAqB;AACvB;;AAEA,qCAAqC;AACrC;EACE,sBAAsB;EACtB,iBAAiB;AACnB;;;AAGA,4BAA4B;AAC5B;EACE,SAAO;EACP,aAAa;EACb,gBAAgB,EAAE,iCAAiC;EACnD,+DAA+D;EAC/D,uBAAuB,EAAE,oCAAoC;EAC7D,0BAA0B,EAAE,4CAA4C;EACxE;;;;;gEAK8D;AAChE;;AAEA,qBAAqB;AACrB;EACE;IACE,eAAe,EAAE,kCAAkC;IACnD,uBAAuB;EACzB;;EAEA;IACE,eAAe;IACf,gBAAgB;EAClB;AACF;;AAEA,sDAAsD;AACtD;EACE,aAAa,EAAE,oBAAoB;EACnC,sBAAsB;EACtB,YAAY;EACZ,yBAAyB,EAAE,uBAAuB;EAClD,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,wCAAwC;EACxC,gBAAgB,EAAE,8DAA8D;AAClF;;AAEA,2BAA2B;AAC3B;EACE,aAAa;EACb,6BAA6B,EAAE,2CAA2C;EAC1E,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA,iCAAiC;AACjC;EACE,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,sBAAsB;EACtB,eAAe;EACf,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,eAAe,EAAE,kEAAkE;EACnF,SAAS,EAAE,6BAA6B;EACxC,kBAAkB,EAAE,8CAA8C;AACpE;;;;AAIA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,iBAAiB;EACjB,yBAAyB,EAAE,qBAAqB;EAChD,cAAc,EAAE,eAAe;EAC/B,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,sBAAsB;EACtB,mBAAmB,EAAE,sCAAsC;EAC3D,0BAA0B,EAAE,sBAAsB;EAClD,uDAAuD;EACvD,UAAU;AACZ;;AAEA;EACE,yBAAyB,EAAE,gCAAgC;AAC7D;;AAEA;EACE,yBAAyB,EAAE,mCAAmC;EAC9D,cAAc,EAAE,6BAA6B;EAC7C,sBAAsB;EACtB,gCAAgC,EAAE,+CAA+C;EACjF,UAAU,EAAE,sCAAsC;AACpD;;;AAGA;EACE,cAAc;EACd,oBAAoB;EACpB,YAAY;AACd;;AAEA;EACE,qBAAqB,EAAE,wEAAwE;AACjG;;;AAGA,+BAA+B;AAC/B;EACE,SAAO;EACP,aAAa;EACb,yBAAyB;EACzB,sBAAsB;EACtB,kBAAkB,EAAE,2BAA2B;EAC/C,gBAAgB;AAClB;;AAEA,kCAAkC;AAClC;EACE,gBAAgB;EAChB,UAAU;EACV,SAAS;AACX;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,4DAA4D;AAC9D;;AAEA;EACE,yBAAyB;EACzB,wCAAwC;AAC1C;;AAEA;EACE,cAAc;AAChB;;;AAGA,cAAc;AACd;EACE;IACE,aAAa;EACf;;EAEA;IACE,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;EACzB;AACF;;AAEA,wBAAwB;AACxB,uBAAuB;AACvB,wBAAwB;AACxB,6CAA6C;AAC7C;EACE,WAAW;EACX,+BAA+B,EAAE,+EAA+E;EAChH,gBAAgB,EAAE,8BAA8B;EAChD,sBAAsB,EAAE,yCAAyC;EACjE,sBAAsB,EAAE,gCAAgC;EACxD,UAAU;AACZ;;AAEA,UAAU;AACV;EACE,WAAW;EACX,eAAe;EACf,kBAAkB,EAAE,+BAA+B;EACnD,yBAAyB,EAAE,8BAA8B;EACzD,iBAAiB;AACnB;;AAEA,mBAAmB;AACnB;EACE,gBAAgB;EAChB,MAAM,EAAE,+CAA+C;EACvD,WAAW;EACX,uBAAuB;EACvB,0CAA0C,EAAE,iBAAiB;AAC/D;;AAEA;EACE,YAAY;EACZ,sBAAsB;EACtB,gBAAgB;EAChB,yBAAyB,EAAE,+BAA+B;EAC1D,WAAW;EACX,eAAe;EACf,iBAAiB;AACnB;;AAEA;;EAEE,iBAAiB;AACnB;;AAEA;;EAEE,kBAAkB;AACpB;;AAEA;;EAEE,gBAAgB;AAClB;;;AAGA;EACE,yBAAyB,EAAE,uCAAuC;AACpE;;AAEA,qCAAqC;AACrC;;;EAGE,mBAAmB,kBAAkB,+BAA+B;EACpE,sBAAsB;EACtB,kCAAkC,GAAG,yBAAyB;AAChE;;AAEA,kCAAkC;AAClC,kCAAkC,WAAW,EAAE,GAAG,eAAe;AACjE,kCAAkC,YAAY,EAAE,EAAE,UAAU;AAC5D,kCAAkC,WAAW,EAAE,GAAG,qBAAqB;;AAEvE,8EAA8E;AAC9E;;;EAGE,mBAAmB;AACrB;;AAEA,QAAQ;AACR;EACE,YAAY;EACZ,sBAAsB;EACtB,gBAAgB;EAChB,mBAAmB,EAAE,qCAAqC;EAC1D,gBAAgB,EAAE,0BAA0B;EAC5C,uBAAuB,EAAE,oCAAoC;AAC/D;;AAEA,qBAAqB;AACrB;EACE,yBAAyB,EAAE,6BAA6B;AAC1D;;AAEA;EACE,yBAAyB,EAAE,4BAA4B;AACzD;;AAEA;EACE,yBAAyB,EAAE,uCAAuC;AACpE;;AAEA,sBAAsB;AACtB;EACE,oCAAoC,EAAE,oCAAoC;EAC1E,cAAc,EAAE,uBAAuB;EACvC,iBAAiB,EAAE,qBAAqB;EACxC,8BAA8B,EAAE,uBAAuB;AACzD;;AAEA,8CAA8C;AAC9C;EACE,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;;AAGA,+DAA+D;AAC/D;EACE,oCAAoC,EAAE,wCAAwC;AAChF;;;AAGA,6BAA6B;AAC7B,6BAA6B;AAC7B,6BAA6B;;AAE7B,uCAAuC;AACvC;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT;;;;4CAI0C;AAC5C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA,wBAAwB;AACxB;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,kBAAkB;AACpB;;AAEA,2BAA2B;AAC3B;EACE,aAAa;EACb,sBAAsB,EAAE,qCAAqC;EAC7D,QAAQ,EAAE,sCAAsC;EAChD,kBAAkB,EAAE,4BAA4B;EAChD,uBAAuB,EAAE,0CAA0C;EACnE,WAAW,EAAE,0CAA0C;AACzD;;;AAGA;EACE,aAAa;EACb,sBAAsB,EAAE,sCAAsC;EAC9D,eAAe;EACf,gBAAgB,EAAE,sCAAsC;EACxD,iBAAiB,EAAE,yBAAyB;EAC5C,kBAAkB,EAAE,0BAA0B;AAChD;;AAEA;EACE,yBAAyB,EAAE,uBAAuB;EAClD,sBAAsB,EAAE,oBAAoB;EAC5C,YAAY,EAAE,oCAAoC;EAClD,kBAAkB,EAAE,2BAA2B;EAC/C,kBAAkB,EAAE,mBAAmB;EACvC,eAAe,EAAE,2BAA2B;EAC5C,gBAAgB,EAAE,yBAAyB;EAC3C,WAAW,EAAE,6BAA6B;EAC1C,aAAa,EAAE,kCAAkC;EACjD,sBAAsB,EAAE,yBAAyB;EACjD,QAAQ,EAAE,2BAA2B;AACvC;;AAEA;EACE,eAAe,EAAE,2BAA2B;EAC5C,SAAS,EAAE,+BAA+B;EAC1C,UAAU,EAAE,2BAA2B;AACzC;;AAEA;EACE,cAAc,EAAE,qDAAqD;AACvE;;AAEA;EACE,aAAa;EACb,QAAQ,EAAE,kCAAkC;AAC9C;;AAEA;;;EAGE,YAAY;EACZ,eAAe;EACf,sBAAsB;EACtB,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;;;EAGE,YAAY;EACZ,eAAe;EACf,sBAAsB;EACtB,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA,uBAAuB;AACvB;EACE,YAAY;EACZ,YAAY;EACZ,YAAY;EACZ,gBAAgB,EAAE,sCAAsC;AAC1D;;AAEA,wBAAwB;AACxB;EACE,WAAW,EAAE,4BAA4B;EACzC,kBAAkB,EAAE,+BAA+B;AACrD;;;AAGA,sCAAsC;AACtC;EACE,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,WAAW,EAAE,8CAA8C;EAC3D,kBAAkB,EAAE,4BAA4B;AAClD;;AAEA;EACE,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,WAAW,EAAE,8CAA8C;EAC3D,kBAAkB,EAAE,4BAA4B;AAClD;;;AAGA;EACE,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,WAAW,EAAE,8CAA8C;EAC3D,kBAAkB,EAAE,4BAA4B;AAClD;;;AAGA,uDAAuD;AACvD;EACE,YAAY;EACZ,eAAe;EACf,yBAAyB,EAAE,2BAA2B;EACtD,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,qBAAqB,EAAE,iCAAiC;EACxD,2BAA2B,EAAE,mCAAmC;AAClE;;AAEA,qBAAqB;AACrB;EACE,qBAAqB,EAAE,8BAA8B;EACrD,yBAAyB,EAAE,yBAAyB;AACtD;;AAEA;EACE,qBAAqB,EAAE,oCAAoC;AAC7D;;;AAGA,oBAAoB;;AAEpB;;;EAGE,yBAAyB,EAAE,mBAAmB;EAC9C,sBAAsB,EAAE,cAAc;EACtC,WAAW,EAAE,iBAAiB;EAC9B,oBAAoB,EAAE,qCAAqC;AAC7D;;AAEA,+BAA+B;AAC/B;EACE,YAAY,EAAE,wBAAwB;EACtC,YAAY,EAAE,6CAA6C;AAC7D;;AAEA,yBAAyB;AACzB;EACE,yBAAyB,EAAE,kDAAkD;EAC7E,sBAAsB,EAAE,cAAc;EACtC,WAAW,EAAE,iBAAiB;EAC9B,oBAAoB,EAAE,qCAAqC;EAC3D,gBAAgB,EAAE,gDAAgD;AACpE;;;AAGA,mBAAmB;AACnB;EACE,gBAAgB,EAAE,sCAAsC;EACxD,WAAW;EACX,YAAY;EACZ,SAAS;EACT,eAAe;AACjB;;AAEA,sBAAsB;AACtB;EACE,gBAAgB,EAAE,0BAA0B;EAC5C,yBAAyB,EAAE,mBAAmB;EAC9C,sBAAsB,EAAE,cAAc;EACtC,WAAW;EACX,YAAY;EACZ,oBAAoB,EAAE,wBAAwB;EAC9C,mBAAmB,EAAE,wBAAwB;EAC7C,uBAAuB,EAAE,2BAA2B;EACpD,kBAAkB;EAClB,mBAAmB,EAAE,8BAA8B;EACnD,oBAAoB,EAAE,uBAAuB;AAC/C;;AAEA;EACE,YAAY;EACZ,eAAe,EAAE,mCAAmC;EACpD,WAAW,EAAE,YAAY;AAC3B;;AAEA,+BAA+B;AAC/B;EACE,aAAa,EAAE,mCAAmC;EAClD,mBAAmB,EAAE,sBAAsB;EAC3C,eAAe,EAAE,oCAAoC;EACrD,iBAAiB,EAAE,oCAAoC;EACvD,qBAAqB,EAAE,8CAA8C;EACrE,QAAQ,EAAE,uCAAuC;EACjD,mBAAmB,EAAE,uCAAuC;AAC9D;;;;AAIA,iCAAiC;AACjC;EACE;MACI,sBAAsB;MACtB,SAAS;EACb;;EAEA;MACI,eAAe;EACnB;AACF;;AAEA,gCAAgC;AAChC,+BAA+B;AAC/B,8BAA8B;;AAE9B,iCAAiC;AACjC;EACE,yBAAyB,EAAE,wCAAwC;EACnE,sBAAsB,EAAE,oBAAoB;EAC5C,aAAa,EAAE,kDAAkD;EACjE,kBAAkB,EAAE,+CAA+C;EACnE,mBAAmB,EAAE,kCAAkC;EACvD,eAAe,EAAE,2BAA2B;EAC5C,WAAW,EAAE,mBAAmB;EAChC,aAAa,EAAE,uBAAuB;EACtC,sBAAsB;EACtB,QAAQ,EAAE,0CAA0C;AACtD;;AAEA,oCAAoC;AACpC;EACE,aAAa,EAAE,qDAAqD;EACpE,mBAAmB,EAAE,yBAAyB;EAC9C,eAAe,EAAE,6BAA6B;EAC9C,gBAAgB,EAAE,oBAAoB;EACtC,cAAc,EAAE,yBAAyB;EACzC,QAAQ,EAAE,sCAAsC;EAChD,mBAAmB,EAAE,+BAA+B;AACtD;;AAEA;EACE,WAAW,EAAE,uCAAuC;EACpD,iBAAiB,EAAE,iCAAiC;AACtD;;AAEA;EACE,mBAAmB,EAAE,sCAAsC;AAC7D;;;AAGA,WAAW;AACX,WAAW;AACX,WAAW;;;AAGX;EACE,aAAa,EAAE,mCAAmC;EAClD,2BAA2B,EAAE,4DAA4D;EACzF,SAAS,EAAE,2BAA2B;EACtC,gBAAgB,EAAE,6CAA6C;AACjE;;;AAGA;iCACiC;AACjC,mDAAmD;AACnD;EACE,qBAAqB;EACrB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,YAAY,EAAE,+CAA+C;EAC7D,4DAA4D;AAC9D;;AAEA,wBAAwB;AACxB;EACE,yBAAyB,EAAE,iBAAiB;EAC5C,cAAc;AAChB;;AAEA;EACE,yBAAyB,EAAE,kBAAkB;EAC7C,wCAAwC;AAC1C;;AAEA,6BAA6B;AAC7B;EACE,yBAAyB,EAAE,YAAY;EACvC,cAAc;AAChB;;AAEA;EACE,yBAAyB,EAAE,qBAAqB;EAChD,wCAAwC;AAC1C;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW,EAAE,qBAAqB;EAClC,YAAY,EAAE,oBAAoB;EAClC,UAAU,EAAE,2BAA2B;EACvC,sBAAsB,EAAE,sBAAsB;EAC9C,kBAAkB,EAAE,cAAc;EAClC,yBAAyB,EAAE,gBAAgB;EAC3C,WAAW,EAAE,yBAAyB;EACtC,eAAe,EAAE,qBAAqB;EACtC,cAAc,EAAE,+BAA+B;EAC/C,eAAe;EACf,oDAAoD;AACtD;;AAEA;EACE,yBAAyB,EAAE,2BAA2B;EACtD,kBAAkB,EAAE,+BAA+B;AACrD;;AAEA;EACE,yBAAyB,EAAE,eAAe;EAC1C,kBAAkB,EAAE,oBAAoB;AAC1C;;AAEA;EACE,yBAAyB,EAAE,sCAAsC;EACjE,kBAAkB;EAClB,WAAW,EAAE,+BAA+B;EAC5C,mBAAmB;AACrB;;AAEA,gDAAgD;AAChD;EACE,yBAAyB,EAAE,SAAS;EACpC,cAAc;EACd,eAAe,EAAE,gCAAgC;EACjD,WAAW,EAAE,0CAA0C;EACvD,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,4DAA4D;AAC9D;;AAEA;EACE,yBAAyB,EAAE,kCAAkC;AAC/D;;;;AAIA,2BAA2B;AAC3B,2BAA2B;AAC3B,2BAA2B;;AAE3B;EACE,iBAAiB;AACnB;;AAEA;EACE,SAAO;EACP,gBAAgB;AAClB;;AAEA,8BAA8B;AAC9B,8BAA8B;AAC9B,8BAA8B;;AAE9B,sDAAsD;AACtD;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,oCAAoC,EAAE,0BAA0B;EAChE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;AACf;;AAEA,wBAAwB;AACxB;EACE,kBAAkB;EAClB,yBAAyB;EACzB,UAAU;EACV,kBAAkB;EAClB,yCAAyC;EACzC,gBAAgB,EAAE,0DAA0D;EAC5E,UAAU,EAAE,sDAAsD;EAClE,gBAAgB,EAAE,gDAAgD;EAClE,mDAAmD;EACnD,gBAAgB,EAAE,8CAA8C;EAChE,gBAAgB,EAAE,mCAAmC;AACvD;;AAEA,wBAAwB;AACxB;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,6BAA6B;EAC7B,yBAAyB;AAC3B;;AAEA;EACE,SAAS;EACT,eAAe;EACf,WAAW;AACb;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,gBAAgB;EAChB,8BAA8B;AAChC;;AAEA,2BAA2B;AAC3B;EACE,aAAa;EACb,yBAAyB;EACzB,SAAS;EACT,kBAAkB;EAClB,0BAA0B;EAC1B,yBAAyB;AAC3B;;AAEA,sEAAsE;AACtE;EACE,aAAa;EACb,6BAA6B;EAC7B,gBAAgB;EAChB,SAAS,EAAE,sBAAsB;AACnC;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,4DAA4D;AAC9D;;AAEA,6BAA6B;AAC7B;EACE,uBAAuB;EACvB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,WAAW;EACX,mBAAmB;EACnB,UAAU;EACV,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA;EACE,cAAc;AAChB;;AAEA,oBAAoB;AACpB;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,uBAAuB;AACvB;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,iCAAiC;AACjC;EACE;IACE,UAAU;IACV,qBAAqB;EACvB;EACA;IACE,UAAU;IACV,mBAAmB;EACrB;AACF;;AAEA,qBAAqB;AACrB,0EAA0E;AAC1E;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,iBAAiB,SAAS,sCAAsC;EAChE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA,gCAAgC;AAChC;EACE,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA,sBAAsB;AACtB;EACE;IACE,eAAe;IACf,yBAAyB;IACzB,QAAQ;EACV;AACF;;AAEA,mDAAmD;;AAEnD;EACE,YAAY,cAAc,+CAA+C;EACzE,gBAAgB,UAAU,yCAAyC;EACnE,aAAa;EACb,QAAQ;EACR,mBAAmB;EACnB,6BAA6B;AAC/B","sourcesContent":["/* Contenidor principal del Dashboard */\r\n.Dashboard {\r\n  display: flex;\r\n  flex-direction: column;\r\n  height: 100vh;\r\n  /*background-color: #f93939; /* COLOR TOCAT f9f9f9 */\r\n  background: linear-gradient(\r\n    rgba(255, 255, 255, 0.8), \r\n    rgba(255, 255, 255, 0.8)\r\n  ),\r\n  url('../images/31330.jpg') no-repeat center center fixed;\r\n  background-size: cover;\r\n  font-family: Arial, sans-serif; /* Tipografia professional */\r\n}\r\n\r\n/* Barra de menú superior */\r\n.menu-bar {\r\n  display: flex;\r\n  background-color: #f1f1f1; /* Gris claret */\r\n  padding: 10px 20px;\r\n  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.1); /* Ombra subtil */\r\n  align-items: center;\r\n  height: 50px;\r\n}\r\n\r\n/* Menús actius i inactius: sense fons ni quadrats */\r\n.menu-item {\r\n  margin: 0 15px;\r\n  color: #000000; /* Negre per defecte */\r\n  font-size: 16px;\r\n  text-decoration: none; /* Sense subratllat */\r\n  cursor: pointer;\r\n  background: none; /* Elimina qualsevol fons */\r\n  border: none; /* Elimina qualsevol vora o quadrat */\r\n  outline: none; /* Elimina els contorns de focus */\r\n}\r\n\r\n/* Hover per menús actius */\r\n.menu-item:hover {\r\n  font-weight: bold; /* Negreta */\r\n  color: #0078d7; /* Blau per destacar */\r\n  /*text-decoration: underline; /* Subratllat */\r\n}\r\n\r\n/* Menús actius seleccionats */\r\n.menu-item.active {\r\n  font-weight: bold; /* Negreta */\r\n  color: #0078d7; /* Blau per destacar */\r\n  /*text-decoration: underline; /* Subratllat */\r\n}\r\n\r\n/* Menús deshabilitats */\r\n.menu-item.disabled {\r\n  color: #808080; /* Gris fosc */\r\n  cursor: not-allowed; /* Icona de prohibit */\r\n  text-decoration: none; /* Sense subratllat */\r\n}\r\n\r\n/* Contenidor del dropdown */\r\n.dropdown {\r\n  position: relative; \r\n  display: inline-block; /* Per col·locar-lo en línia a la menu-bar */\r\n}\r\n\r\n/* Botó principal del dropdown (ex. \"Productes\") \r\n.dropdown > .menu-item {\r\n  /* Ja tens estil bàsic a .menu-item, \r\n     però si vols afegir algun indicador (fletxeta, etc.) ho pots fer aquí. \r\n}*/\r\n\r\n/* Contenidor del submenú: posició absoluta i no visible per defecte */\r\n.dropdown-content {\r\n  display: none; \r\n  position: absolute; \r\n  background-color: #f1f1f1; /* Pots canviar el color de fons */\r\n  min-width: 160px; /* Amplada mínima */\r\n  box-shadow: 0px 8px 16px rgba(0,0,0,0.2); /* Ombra de submenú */\r\n  padding: 5px 0; /* Espai vertical */\r\n  z-index: 9999; /* Per sobre d'altres elements */\r\n}\r\n\r\n/* Fem que aparegui el submenú en fer hover al .dropdown */\r\n.dropdown:hover .dropdown-content {\r\n  display: block;\r\n}\r\n\r\n/* Estil dels botons o enllaços del submenú */\r\n.dropdown-content .submenu-item {\r\n  display: block;\r\n  width: 100%;\r\n  padding: 8px 16px;\r\n  text-align: left; \r\n  background: none; \r\n  border: none;\r\n  cursor: pointer;\r\n  color: #000; \r\n  font-size: 14px;\r\n  text-decoration: none;\r\n}\r\n\r\n/* Hover a cada element del submenú */\r\n.dropdown-content .submenu-item:hover {\r\n  background-color: #ddd;\r\n  font-weight: bold;\r\n}\r\n\r\n\r\n/* Contingut del Dashboard */\r\n.content {\r\n  flex: 1;\r\n  padding: 20px;\r\n  overflow-y: auto; /* Scroll per continguts llargs */\r\n  /*background-color: #06f390; /* COLOR TOCAT ffffff Fons blanc */\r\n  background: transparent; /* Afegit en comptes de fons blanc */\r\n  border-top: 1px solid #ddd; /* Separació entre la barra i el contingut */\r\n  /*nous\r\n  background: linear-gradient(\r\n        rgba(255, 255, 255, 0.8), \r\n        rgba(255, 255, 255, 0.8)\r\n      ), \r\n      url('../images/31330.jpg') no-repeat center center fixed;*/\r\n}\r\n\r\n/* Barra responsiva */\r\n@media (max-width: 768px) {\r\n  .menu-bar {\r\n    flex-wrap: wrap; /* Reorganitza menús si no caben */\r\n    justify-content: center;\r\n  }\r\n\r\n  .menu-item {\r\n    font-size: 14px;\r\n    margin: 5px 10px;\r\n  }\r\n}\r\n\r\n/* Contenidor principal per a seccions del Dashboard */\r\n.Dashboard-container {\r\n  display: flex; /* Això no es toca */\r\n  flex-direction: column;\r\n  height: 100%;\r\n  background-color: #f3f3f3; /* COLOR TOCAT f3f3f3 */\r\n  font-family: Arial, sans-serif;\r\n  padding: 20px;\r\n  border-radius: 15px;\r\n  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.1);\r\n  overflow: hidden; /* AQUEST FA QUE DESAPAREIXI EL SCROLL SI NO LI FEM AL TBODY */\r\n}\r\n\r\n/* Pestanyes de navegació */\r\n.Dashboard-tabs {\r\n  display: flex;\r\n  border-bottom: 2px solid #ddd; /* Línia de separació per a les pestanyes */\r\n  margin-bottom: 20px;\r\n  position: relative;\r\n}\r\n\r\n/* Barra de cerca reutilitzable */\r\n.Dashboard-search-bar {\r\n  margin-bottom: 10px;\r\n  padding: 8px;\r\n  width: 200px;\r\n  box-sizing: border-box;\r\n  font-size: 14px;\r\n  border: 1px solid #ddd;\r\n  border-radius: 5px;\r\n}\r\n\r\n.Dashboard-search-container {\r\n  display: flex;\r\n  flex-wrap: wrap; /* Permet que els elements es reorganitzin si l'espai és limitat */\r\n  gap: 10px; /* Espai entre els elements */\r\n  margin-bottom: 0px; /* Coherència amb altres files del formulari */\r\n}\r\n\r\n\r\n\r\n.Dashboard-tab {\r\n  position: relative;\r\n  padding: 10px 20px;\r\n  margin-right: 5px;\r\n  background-color: #f1f1f1; /* Fons gris claret */\r\n  color: #000000; /* Text negre */\r\n  font-size: 14px;\r\n  font-weight: bold;\r\n  text-align: center;\r\n  cursor: pointer;\r\n  border: 1px solid #ddd;\r\n  border-bottom: none; /* Fusiona amb el fons del contingut */\r\n  border-radius: 8px 8px 0 0; /* Forma de pestanya */\r\n  transition: background-color 0.3s ease, color 0.3s ease;\r\n  z-index: 1;\r\n}\r\n\r\n.Dashboard-tab:hover {\r\n  background-color: #e0e0e0; /* Canvia a gris clar en hover */\r\n}\r\n\r\n.Dashboard-tab.active {\r\n  background-color: #ffffff; /* Fons blanc per pestanya activa */\r\n  color: #0078d7; /* Blau per pestanya activa */\r\n  border: 1px solid #ddd;\r\n  border-bottom: 2px solid #ffffff; /* Amaga la línia inferior per semblar activa */\r\n  z-index: 2; /* Posa la pestanya activa al davant */\r\n}\r\n\r\n\r\n.Dashboard-tab.disabled {\r\n  color: #808080;\r\n  pointer-events: none;\r\n  opacity: 0.5;\r\n}\r\n\r\n.Dashboard-tabs.subtaula .Dashboard-tab {\r\n  color: red !important; /* Usa !important si el codi original té un color també amb !important */\r\n}\r\n\r\n\r\n/* Contingut de les pestanyes */\r\n.Dashboard-content {\r\n  flex: 1;\r\n  padding: 20px;\r\n  background-color: #f9f9f9;\r\n  border: 1px solid #ddd;\r\n  border-radius: 5px; /* Cantonades arrodonides */\r\n  overflow-y: auto;\r\n}\r\n\r\n/* Llista general per a elements */\r\n.Dashboard-list {\r\n  list-style: none;\r\n  padding: 0;\r\n  margin: 0;\r\n}\r\n\r\n.Dashboard-item {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  padding: 10px;\r\n  margin-bottom: 10px;\r\n  background-color: #ffffff;\r\n  border: 1px solid #ddd;\r\n  border-radius: 5px;\r\n  cursor: pointer;\r\n  transition: background-color 0.3s ease, box-shadow 0.3s ease;\r\n}\r\n\r\n.Dashboard-item:hover {\r\n  background-color: #f1f1f1;\r\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\r\n}\r\n\r\n.Dashboard-item strong {\r\n  color: #000000;\r\n}\r\n\r\n\r\n/* Responsiu */\r\n@media (max-width: 768px) {\r\n  .Dashboard-container {\r\n    padding: 10px;\r\n  }\r\n\r\n  .Dashboard-tab {\r\n    font-size: 12px;\r\n    padding: 8px 12px;\r\n  }\r\n\r\n  .Dashboard-item {\r\n    flex-direction: column;\r\n    align-items: flex-start;\r\n  }\r\n}\r\n\r\n/***********************/\r\n/* Taules de selecció */\r\n/***********************/\r\n/* Contenidor global per mantenir el scroll */\r\n.Dashboard-table-container {\r\n  width: 100%;\r\n  max-height: calc(100vh - 262px); /* Barra d'accions. Canvi de 220 a 262. Espai disponible per a taula completa */\r\n  overflow-y: auto; /* Activa el scroll vertical */\r\n  border: 1px solid #ddd; /* Opcional: per fer visible els límits */\r\n  box-sizing: border-box; /* Assegura alineació de mides */\r\n  padding: 0;\r\n}\r\n\r\n/* Taula */\r\n.Dashboard-table {\r\n  width: 100%;\r\n  font-size: 14px;\r\n  table-layout: auto; /* Alineació segons contingut */\r\n  border-collapse: separate; /* Manté les vores separades */\r\n  border-spacing: 0;\r\n}\r\n\r\n/* Capçalera fixa */\r\n.Dashboard-table thead {\r\n  position: sticky;\r\n  top: 0; /* Manté la capçalera fixa a la part superior */\r\n  z-index: 10;\r\n  background-color: white;\r\n  box-shadow: 0px 2px 5px rgba(0, 0, 0, 0.1); /* Ombra subtil */\r\n}\r\n\r\n.Dashboard-table th {\r\n  padding: 8px;\r\n  border: 1px solid #ddd;\r\n  text-align: left;\r\n  background-color: #f4f4f9; /* Fons per a l'encapçalament */\r\n  color: #333;\r\n  cursor: pointer;\r\n  font-weight: bold;\r\n}\r\n\r\n.Dashboard-table th.text-right,\r\n.Dashboard-table td.text-right {\r\n  text-align: right;\r\n}\r\n\r\n.Dashboard-table th.text-center,\r\n.Dashboard-table td.text-center {\r\n  text-align: center;\r\n}\r\n\r\n.Dashboard-table th.text-left,\r\n.Dashboard-table td.text-left {\r\n  text-align: left;\r\n}\r\n\r\n\r\n.Dashboard-table th:hover {\r\n  background-color: #e0e0e0; /* Canvia el fons al passar per sobre */\r\n}\r\n\r\n/* Columnes compactes per data/hora */\r\n.Dashboard-table .col-date,\r\n.Dashboard-table .col-time,\r\n.Dashboard-table .col-datetime {\r\n  white-space: nowrap;                 /* evita salts de línia al TD */\r\n  /*text-align: center;*/\r\n  font-variant-numeric: tabular-nums;  /* monoespai per xifres */\r\n}\r\n\r\n/* amples per caràcters visibles */\r\n.Dashboard-table .col-date      { width: 12ch; }  /* 10/10/2025 */\r\n.Dashboard-table .col-time      { width: 7.5ch; } /* 16:40 */\r\n.Dashboard-table .col-datetime  { width: 19ch; }  /* 10/10/2025 16:40 */\r\n\r\n/* deixa que el text del TH pugui trencar si és llarg (\"Data Creació\", etc.) */\r\n.Dashboard-table th.col-date,\r\n.Dashboard-table th.col-time,\r\n.Dashboard-table th.col-datetime {\r\n  white-space: normal;\r\n}\r\n\r\n/* Cos */\r\n.Dashboard-table tbody td {\r\n  padding: 8px;\r\n  border: 1px solid #ddd;\r\n  text-align: left;\r\n  white-space: nowrap; /* Evita que el text trenqui línies */\r\n  overflow: hidden; /* Amaga text desbordant */\r\n  text-overflow: ellipsis; /* Afegeix punts suspensius si cal */\r\n}\r\n\r\n/* Files alternades */\r\n.Dashboard-table tbody tr:nth-child(even) {\r\n  background-color: #f9f9f9; /* Fons per a files parells */\r\n}\r\n\r\n.Dashboard-table tbody tr:nth-child(odd) {\r\n  background-color: #ffffff; /* Fons per a files senars */\r\n}\r\n\r\n.Dashboard-table tbody tr:hover {\r\n  background-color: #d3d3d3; /* Canvia el fons al passar per sobre */\r\n}\r\n\r\n/* Fila seleccionada */\r\n.Dashboard-table tbody .selected-row {\r\n  background-color: #cce5ff !important; /* Blau clar per fila seleccionada */\r\n  color: #004085; /* Blau fosc pel text */\r\n  font-weight: bold; /* Ressalta el text */\r\n  border-left: 4px solid #007bff; /* Línia a l'esquerra */\r\n}\r\n\r\n/* Ajust per al text de la fila seleccionada */\r\n.Dashboard-table tbody .selected-row td {\r\n  padding: 8px;\r\n  text-align: left;\r\n}\r\n\r\n.Dashboard-table tbody .selected-row td.text-right {\r\n  text-align: right;\r\n}\r\n\r\n.Dashboard-table tbody .selected-row td.text-center {\r\n  text-align: center;\r\n}\r\n\r\n.Dashboard-table tbody .selected-row td.text-left {\r\n  text-align: left;\r\n}\r\n\r\n\r\n/* Opcional: efecte hover diferenciat per a fila seleccionada */\r\n.Dashboard-table tbody .selected-row:hover {\r\n  background-color: #b3d7ff !important; /* Blau més intens al passar el ratolí */\r\n}\r\n\r\n\r\n/****************************/\r\n/* Camps de plenat de dades */\r\n/****************************/\r\n\r\n/* Contenidor principal del formulari */\r\n.Dashboard-form {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 20px;\r\n  /*padding: 20px;\r\n  background-color: #ffffff;\r\n  border: 1px solid #ddd;\r\n  border-radius: 5px;\r\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);*/\r\n}\r\n\r\n.Dashboard-cerca {\r\n  display: flex;\r\n  flex-direction: row;\r\n  gap: 20px;\r\n}\r\n\r\n/* Files del formulari */\r\n.Dashboard-form-row {\r\n  display: flex;\r\n  flex-wrap: wrap;\r\n  gap: 10px;\r\n  margin-bottom: 0px;\r\n}\r\n\r\n/* Columnes del formulari */\r\n.Dashboard-form-column {\r\n  display: flex;\r\n  flex-direction: column; /* Col·loca els elements en columna */\r\n  gap: 0px; /* Espai vertical entre els elements */\r\n  margin-bottom: 0px; /* Espai inferior del bloc */\r\n  align-items: flex-start; /* Alinea elements a l'inici horitzontal */\r\n  width: 100%; /* Assegura que ocupa l'ample disponible */\r\n}\r\n\r\n\r\n.Dashboard-form label {\r\n  display: flex;\r\n  flex-direction: column; /* Organitza el contingut en columna */\r\n  font-size: 14px;\r\n  max-width: 250px; /* Ajusta si vols un màxim d'amplada */\r\n  font-weight: bold; /* Destaquem els labels */\r\n  margin-bottom: 0px; /* Separació entre camps */\r\n}\r\n\r\n.Dashboard-info-container {\r\n  background-color: #f9f9f9; /* Fons clar i neutre */\r\n  border: 1px solid #ddd; /* Frontera subtil */\r\n  padding: 0px; /* Espai intern per a llegibilitat */\r\n  border-radius: 4px; /* Cantonades arrodonides */\r\n  margin-bottom: 5px; /* Espai inferior */\r\n  font-size: 14px; /* Mida moderada del text */\r\n  line-height: 1.6; /* Espaiat entre línies */\r\n  color: #333; /* Color del text principal */\r\n  display: flex; /* Layout per adaptar continguts */\r\n  flex-direction: column; /* Col·locar en columna */\r\n  gap: 0px; /* Separació entre línies */\r\n}\r\n\r\n.Dashboard-info-container strong {\r\n  display: inline; /* Manté el text en línia */\r\n  margin: 0; /* Elimina marges per defecte */\r\n  padding: 0; /* Elimina espais interns */\r\n}\r\n\r\n.Dashboard-info-container br {\r\n  line-height: 0; /* Elimina espai vertical extra pels salts de línia */\r\n}\r\n\r\n.Dashboard-info-container .info-inline {\r\n  display: flex;\r\n  gap: 2px; /* Espai entre Categoria i Tipus */\r\n}\r\n\r\n.Dashboard-form input,\r\n.Dashboard-form textarea,\r\n.Dashboard-form select {\r\n  padding: 5px;\r\n  font-size: 14px;\r\n  border: 1px solid #ccc;\r\n  border-radius: 4px;\r\n  box-sizing: border-box;\r\n}\r\n\r\n.Dashboard-cerca input,\r\n.Dashboard-cerca textarea,\r\n.Dashboard-cerca select {\r\n  padding: 5px;\r\n  font-size: 14px;\r\n  border: 1px solid #ccc;\r\n  border-radius: 4px;\r\n  box-sizing: border-box;\r\n}\r\n\r\n/* Textarea específic */\r\n.Dashboard-form textarea {\r\n  height: 60px;\r\n  width: 600px;\r\n  color: black;\r\n  resize: vertical; /* Permet ajustar només verticalment */\r\n}\r\n\r\n/* Textarea transitori */\r\n.Dashboard-form textarea.textarea-trans {\r\n  color: gray; /* Text transitori en gris */\r\n  font-style: italic; /* Text transitori en cursiva */\r\n}\r\n\r\n\r\n/* Inputs personalitzats per amplada */\r\n.Dashboard-form .camp-llarg-input {\r\n  width: 250px;\r\n  color: black;\r\n}\r\n\r\n.Dashboard-form .camp-llarg-input-trans {\r\n  color: gray; /* Només canviem el color al mode transitori */\r\n  font-style: italic; /* Opcional: estil cursiva */\r\n}\r\n\r\n.Dashboard-form .camp-curt-input {\r\n  width: 125px;\r\n  color: black;\r\n}\r\n\r\n.Dashboard-form .camp-curt-input-trans {\r\n  color: gray; /* Només canviem el color al mode transitori */\r\n  font-style: italic; /* Opcional: estil cursiva */\r\n}\r\n\r\n\r\n.Dashboard-form .camp-mig-input {\r\n  width: 200px;\r\n  color: black;\r\n}\r\n\r\n.Dashboard-form .camp-mig-input-trans {\r\n  color: gray; /* Només canviem el color al mode transitori */\r\n  font-style: italic; /* Opcional: estil cursiva */\r\n}\r\n\r\n\r\n/* Camps específics per Professions i Tipus de Client */\r\n.Dashboard-form .custom-input {\r\n  padding: 5px;\r\n  font-size: 14px;\r\n  border: 1px solid #007bff; /* Blau suau per destacar */\r\n  border-radius: 4px;\r\n  box-sizing: border-box;\r\n}\r\n\r\n.Dashboard-form .custom-input:focus {\r\n  outline: none;\r\n  border-color: #0056b3; /* Blau més intens al fer focus */\r\n  box-shadow: 0 0 4px #0056b3; /* Ombra subtil per indicar focus */\r\n}\r\n\r\n/* Error en el camp */\r\n.Dashboard-form .custom-input.error {\r\n  border-color: #dc3545; /* Vermell per indicar error */\r\n  background-color: #f8d7da; /* Vermell clar de fons */\r\n}\r\n\r\n.Dashboard-form .custom-input.error:focus {\r\n  border-color: #bd2130; /* Vermell més intens al fer focus */\r\n}\r\n\r\n\r\n/* camps read_only */\r\n\r\n.Dashboard-form .readonly-input,\r\n.Dashboard-form .readonly-textarea,\r\n.Dashboard-form .readonly-checkbox {\r\n  background-color: #f5f5f5; /* Fons gris clar */\r\n  border: 1px solid #ccc; /* Vora suau */\r\n  color: #666; /* Text en gris */\r\n  pointer-events: none; /* Evita interaccions amb el ratolí */\r\n}\r\n\r\n/* Específic per als textarea */\r\n.Dashboard-form .readonly-textarea {\r\n  resize: none; /* Evita redimensionar */\r\n  height: auto; /* Ajusta automàticament a la mida del text */\r\n}\r\n\r\n/* Específic per select */\r\n.Dashboard-form .readonly-select {\r\n  background-color: #f5f5f5; /* Fons gris clar, com els altres camps inactius */\r\n  border: 1px solid #ccc; /* Vora suau */\r\n  color: #666; /* Text en gris */\r\n  pointer-events: none; /* Evita interaccions amb el ratolí */\r\n  appearance: none; /* Elimina l'estil predeterminat del navegador */\r\n}\r\n\r\n\r\n/* Checkbox actiu */\r\n.Dashboard-form .readonly-checkbox {\r\n  appearance: auto; /* Estil natiu per checkbox editable */\r\n  width: 16px;\r\n  height: 16px;\r\n  margin: 0;\r\n  cursor: pointer;\r\n}\r\n\r\n/* Checkbox readonly */\r\n.Dashboard-form .readonly-checkbox.readonly-input {\r\n  appearance: none; /* Elimina l'estil natiu */\r\n  background-color: #e0e0e0; /* Fons gris clar */\r\n  border: 1px solid #ccc; /* Vora gris */\r\n  width: 16px;\r\n  height: 16px;\r\n  display: inline-flex; /* Centrat amb flexbox */\r\n  align-items: center; /* Centra verticalment */\r\n  justify-content: center; /* Centra horitzontalment */\r\n  position: relative;\r\n  cursor: not-allowed; /* Indica que no és editable */\r\n  pointer-events: none; /* Evita interaccions */\r\n}\r\n\r\n.Dashboard-form .readonly-checkbox.readonly-input:checked::before {\r\n  content: '✔';\r\n  font-size: 12px; /* Mida consistent amb els actius */\r\n  color: #fff; /* ✔ blanc */\r\n}\r\n\r\n/* Checkbox label amb espaiat */\r\n.Dashboard-form .checkbox-label {\r\n  display: flex; /* Col·loca els elements en línia */\r\n  flex-direction: row; /* Organitza en fila */\r\n  font-size: 14px; /* Manté la mida del text uniforme */\r\n  font-weight: bold; /* Coherència amb altres etiquetes */\r\n  align-items: baseline; /* Alinea amb la línia de text de l'etiqueta */\r\n  gap: 5px; /* Espai entre el label i el checkbox */\r\n  margin-bottom: 15px; /* Mateixa separació que altres camps */\r\n}\r\n\r\n\r\n\r\n/* Resposta a pantalles petites */\r\n@media (max-width: 768px) {\r\n  .Dashboard-form-row {\r\n      flex-direction: column;\r\n      gap: 10px;\r\n  }\r\n\r\n  .Dashboard-form label {\r\n      max-width: 100%;\r\n  }\r\n}\r\n\r\n/*******************************/\r\n/* Camps de consulta de dades */\r\n/*****************************/\r\n\r\n/* Secció general del formulari */\r\n.Dashboard-form-section {\r\n  background-color: #f9f9f9; /* Fons clar i neutre per consistència */\r\n  border: 1px solid #ddd; /* Frontera subtil */\r\n  padding: 10px; /* Espai intern més generós per separar elements */\r\n  border-radius: 4px; /* Cantonades arrodonides per harmonia visual */\r\n  margin-bottom: 10px; /* Espai inferior entre seccions */\r\n  font-size: 14px; /* Mida moderada del text */\r\n  color: #333; /* Color del text */\r\n  display: flex; /* Disseny en columna */\r\n  flex-direction: column;\r\n  gap: 6px; /* Separació entre línies dins la secció */\r\n}\r\n\r\n/* Estil per a línies d'informació */\r\n.info-inline {\r\n  display: flex; /* Layout flexible per col·locar etiquetes i valors */\r\n  align-items: center; /* Centrar verticalment */\r\n  font-size: 14px; /* Mida del text consistent */\r\n  line-height: 1.4; /* Espaiat moderat */\r\n  padding: 2px 0; /* Lleuger espai intern */\r\n  gap: 0px; /* Espai entre l'etiqueta i el valor */\r\n  border-bottom: none; /* Treu la línia de separació */\r\n}\r\n\r\n.info-inline strong {\r\n  color: #555; /* Color més destacat per a etiquetes */\r\n  margin-right: 8px; /* Espai entre etiqueta i valor */\r\n}\r\n\r\n.info-inline:last-child {\r\n  border-bottom: none; /* Treure la línia a l'últim element */\r\n}\r\n\r\n\r\n/**********/\r\n/* Botons */\r\n/**********/\r\n\r\n\r\n.Dashboard-button-group {\r\n  display: flex; /* Col·loca els elements en línia */\r\n  justify-content: flex-start; /* Ajusta segons el disseny: start, center o space-between */\r\n  gap: 10px; /* Espai entre els botons */\r\n  margin-top: 20px; /* Opcional: separació superior dels botons */\r\n}\r\n\r\n\r\n/* Estils generals per als botons del Dashboard \r\n/* Botó d'Acceptar i Cancel·lar */\r\n/* Estil base per a tots els botons del dashboard */\r\n.Dashboard-btn {\r\n  display: inline-block;\r\n  padding: 10px 15px;\r\n  font-size: 14px;\r\n  font-weight: bold;\r\n  text-align: center;\r\n  cursor: pointer;\r\n  border: none;\r\n  border-radius: 5px;\r\n  width: 100px; /* Amplada fixa com el botó d'inici de sessió */\r\n  transition: background-color 0.3s ease, box-shadow 0.3s ease;\r\n}\r\n\r\n/* Botó Acceptar: Blau */\r\n.Dashboard-btn-acceptar {\r\n  background-color: #0078d7; /* Blau primari */\r\n  color: #ffffff;\r\n}\r\n\r\n.Dashboard-btn-acceptar:hover {\r\n  background-color: #005a9e; /* Blau més fosc */\r\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);\r\n}\r\n\r\n/* Botó Cancel·lar: Vermell */\r\n.Dashboard-btn-cancelar {\r\n  background-color: #d9534f; /* Vermell */\r\n  color: #ffffff;\r\n}\r\n\r\n.Dashboard-btn-cancelar:hover {\r\n  background-color: #c9302c; /* Vermell més fosc */\r\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);\r\n}\r\n\r\n.Dashboard-btn-icona {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  width: 30px; /* Amplada del botó */\r\n  height: 30px; /* Alçada del botó */\r\n  padding: 0; /* Eliminem padding extra */\r\n  border: 1px solid #ccc; /* Frontera coherent */\r\n  border-radius: 50%; /* Botó rodó */\r\n  background-color: #f5f5f5; /* Fons subtil */\r\n  color: #333; /* Color del text/icona */\r\n  font-size: 16px; /* Mida de la icona */\r\n  line-height: 1; /* Evitem espais innecessaris */\r\n  cursor: pointer;\r\n  transition: background-color 0.2s, border-color 0.2s;\r\n}\r\n\r\n.Dashboard-btn-icona:hover {\r\n  background-color: #e0e0e0; /* Canvi de fons en hover */\r\n  border-color: #999; /* Canvi de frontera en hover */\r\n}\r\n\r\n.Dashboard-btn-icona:active {\r\n  background-color: #d6d6d6; /* Fons actiu */\r\n  border-color: #666; /* Frontera activa */\r\n}\r\n\r\n.Dashboard-btn-icona:disabled {\r\n  background-color: #f5f5f5; /* Fons neutre per botó deshabilitat */\r\n  border-color: #ccc;\r\n  color: #999; /* Color del text més pàl·lid */\r\n  cursor: not-allowed;\r\n}\r\n\r\n/* 🔹 Botons de Navegació (Anterior / Següent) */\r\n.Dashboard-btn-navegar {\r\n  background-color: #a0a0a0; /* Gris */\r\n  color: #ffffff;\r\n  font-size: 24px; /* Mida gran per a les fletxes */\r\n  width: 60px; /* Mida més petita que els altres botons */\r\n  height: 40px;\r\n  padding: 5px;\r\n  border-radius: 5px;\r\n  transition: background-color 0.3s ease, box-shadow 0.3s ease;\r\n}\r\n\r\n.Dashboard-btn-navegar:hover {\r\n  background-color: #888888; /* Un gris més fosc al passar-hi */\r\n}\r\n\r\n\r\n\r\n/**************************/\r\n/* Mostrar Camps Estàtics */\r\n/**************************/\r\n\r\n.Dashboard-form-row label {\r\n  font-weight: bold;\r\n}\r\n\r\n.Dashboard-form-row span {\r\n  flex: 1;\r\n  text-align: left;\r\n}\r\n\r\n/*****************************/\r\n/* Modals: Finestra emergent */\r\n/*****************************/\r\n\r\n/* Fons del modal que bloqueja la resta de la pàgina */\r\n.Dashboard-modal-overlay {\r\n  position: fixed;\r\n  top: 0;\r\n  left: 0;\r\n  width: 100%;\r\n  height: 100%;\r\n  background-color: rgba(0, 0, 0, 0.5); /* Fons semi-transparent */\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  z-index: 1000;\r\n}\r\n\r\n/* Contingut del modal */\r\n.Dashboard-modal-content {\r\n  position: relative;\r\n  background-color: #ffffff;\r\n  padding: 0;\r\n  border-radius: 8px;\r\n  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);\r\n  max-width: 500px; /* L'amplada màxima augmentada per contingut més complex */\r\n  width: 90%; /* Afegeix més flexibilitat per a dispositius petits */\r\n  text-align: left; /* Ajusta l'alineació per a contingut detallat */\r\n  animation: Dashboard-modal-fade-in 0.3s ease-in-out;\r\n  overflow: hidden; /* Amaga overflow per mantenir border-radius */\r\n  max-height: 90vh; /* Evita que surti de la pantalla */\r\n}\r\n\r\n/* Capçalera del modal */\r\n.Dashboard-modal-header {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  padding: 15px 20px;\r\n  border-bottom: 1px solid #ddd;\r\n  background-color: #f9f9f9;\r\n}\r\n\r\n.Dashboard-modal-header h3 {\r\n  margin: 0;\r\n  font-size: 18px;\r\n  color: #333;\r\n}\r\n\r\n/* Cos del modal */\r\n.Dashboard-modal-body {\r\n  padding: 20px;\r\n  overflow-y: auto;\r\n  max-height: calc(90vh - 150px);\r\n}\r\n\r\n/* Peu del modal (botons) */\r\n.Dashboard-modal-footer {\r\n  display: flex;\r\n  justify-content: flex-end;\r\n  gap: 10px;\r\n  padding: 15px 20px;\r\n  border-top: 1px solid #ddd;\r\n  background-color: #f9f9f9;\r\n}\r\n\r\n/* Botons del modal (antiga estructura, mantenir per compatibilitat) */\r\n.Dashboard-modal-buttons {\r\n  display: flex;\r\n  justify-content: space-around;\r\n  margin-top: 20px;\r\n  gap: 10px; /* Separa els botons */\r\n}\r\n\r\n.Dashboard-modal-buttons button {\r\n  padding: 10px 20px;\r\n  font-size: 14px;\r\n  font-weight: bold;\r\n  border: none;\r\n  border-radius: 5px;\r\n  cursor: pointer;\r\n  transition: background-color 0.3s ease, box-shadow 0.3s ease;\r\n}\r\n\r\n/* Botó per tancar el modal */\r\n.Dashboard-modal-close {\r\n  background: transparent;\r\n  border: none;\r\n  font-size: 24px;\r\n  cursor: pointer;\r\n  color: #666;\r\n  font-weight: normal;\r\n  padding: 0;\r\n  width: 30px;\r\n  height: 30px;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  transition: color 0.2s;\r\n}\r\n\r\n.Dashboard-modal-close:hover {\r\n  color: #d9534f;\r\n}\r\n\r\n/* Botó d'acceptar */\r\n.Dashboard-modal-buttons .accept-btn {\r\n  background-color: #0078d7;\r\n  color: #ffffff;\r\n}\r\n\r\n.Dashboard-modal-buttons .accept-btn:hover {\r\n  background-color: #005a9e;\r\n}\r\n\r\n/* Botó de cancel·lar */\r\n.Dashboard-modal-buttons .cancel-btn {\r\n  background-color: #d9534f;\r\n  color: #ffffff;\r\n}\r\n\r\n.Dashboard-modal-buttons .cancel-btn:hover {\r\n  background-color: #c9302c;\r\n}\r\n\r\n/* Opcional: Animació del modal */\r\n@keyframes Dashboard-modal-fade-in {\r\n  from {\r\n    opacity: 0;\r\n    transform: scale(0.9);\r\n  }\r\n  to {\r\n    opacity: 1;\r\n    transform: scale(1);\r\n  }\r\n}\r\n\r\n/* Menús a la dreta */\r\n/* Layout esquerra/dreta de la barra superior (no trepitja res existent) */\r\n.menu-left {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 8px;\r\n}\r\n\r\n.menu-right {\r\n  margin-left: auto;        /* empeny aquest bloc cap a la dreta */\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 8px;\r\n}\r\n\r\n/* Xip d'empresa activa (opc.) */\r\n.empresa-chip {\r\n  padding: 4px 8px;\r\n  border-radius: 12px;\r\n  background: #f1f1f1;;\r\n  font-size: 0.9rem;\r\n}\r\n\r\n/* Responsive (opc.) */\r\n@media (max-width: 768px) {\r\n  .menu-right {\r\n    flex-wrap: wrap;\r\n    justify-content: flex-end;\r\n    gap: 6px;\r\n  }\r\n}\r\n\r\n/*Afegit per scroll últim ítem amb barra d'accions*/\r\n\r\n.action-toolbar {\r\n  height: 42px;             /* alçada fixa perquè el càlcul sigui estable */\r\n  padding: 6px 8px;         /* igual que ara, però la “height” mana */\r\n  display: flex;\r\n  gap: 8px;\r\n  align-items: center;\r\n  border-bottom: 1px solid #eee;\r\n}\r\n\r\n\r\n\r\n\r\n\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
